import { render, staticRenderFns } from "./DMID.vue?vue&type=template&id=5a8419fe&"
import script from "./DMID.vue?vue&type=script&lang=js&"
export * from "./DMID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports